// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CreditCardOutlinedSvg from "@fishx/icons-svg/es/asn/CreditCardOutlined";
import FishxIcon from '../components/FishxIcon';

var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardOutlinedSvg
  }));
};

CreditCardOutlined.displayName = 'CreditCardOutlined';
export default React.forwardRef(CreditCardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CreditCardOutlined.js
// module id = 2339
// module chunks = 0